import React, { useEffect, useState } from "react";
import { Box, Typography, TableCell, Fab } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  StyledTableCell,
  StyledTableRow,
  TableWrapper,
} from "../../../../component";
import ApiManager from "../../../../services/api-manager";
import usePageTitle from "../../../../hooks/use-page-title";
import Utils from "../../../../utils/utils";

const AttendeeSpendingReport = () => {
  usePageTitle("Attendee Spending Report");
  const [isLoading, setIsLoading] = useState(false);
  const [records, setRecords] = useState(null);
  const { id, ticketID } = useParams();
  const navigate = useNavigate();
  const { user, loggedEvent } = useSelector((state) => state.storeReducer);
  const _role = user?.role === "super_admin" ? "superAdmin" : "organizer";
  const _symbol = loggedEvent.currencySymbol;

  useEffect(() => {
    getData();
  }, [id]);

  const getData = async (_search = "") => {
    try {
      setIsLoading(true);
      let { data } = await ApiManager(
        "get",
        `${_role}/attendee-spendings/${ticketID}`,
        // `${_role}/attendee-spendings/6f522c2c-4960-4b89-bdfd-2c689b3cc64d`
      );
      console.log("showing data: ", data);
      setRecords(data);
    } catch (error) {
      console.log("🚀 ~ file: events.js:47 ~ getData ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Box>
        <Fab
          size="small"
          onClick={() =>
            navigate(`/event/${id}/management/lead-capture/attendee-report`)
          }
        >
          <ArrowBackIcon />
        </Fab>
        <Typography variant="h4" color="initial" fontWeight={"bold"} m={2}>
          Spendings {_symbol}
          {records?.sum_of_total_amount
            ? Utils.formatWithSuffix(records?.sum_of_total_amount)
            : "0"}
        </Typography>

        <TableWrapper
          spanTd={thLabels.length}
          isLoading={isLoading}
          isContent={records?.all_order_items?.length || false}
          thContent={
            <>
              {thLabels.map((v) => (
                <TableCell key={v}>{v}</TableCell>
              ))}
            </>
          }
        >
          {records?.all_order_items?.map((item, i) => (
            <StyledTableRow key={i}>
              <StyledTableCell>{item?.product_id}</StyledTableCell>
              <StyledTableCell>{item?.product?.name}</StyledTableCell>
              <StyledTableCell>
                {_symbol}
                {item?.price}
              </StyledTableCell>
              <StyledTableCell>{item?.quantity}</StyledTableCell>
              <StyledTableCell>
                {_symbol}
                {item?.sub_total}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableWrapper>
      </Box>
    </div>
  );
};

const thLabels = ["ID", "Product Name", "Price", "Quantity", "Total Amount"];

export default AttendeeSpendingReport;
